namespace Matrix.Visualizer {
    export interface GraphParameterForm {
        GraphKey: Serenity.LookupEditor;
        ThemeKey: Serenity.LookupEditor;
        InstanceKey: Serenity.LookupEditor;
        NodeKey: FormatLookupEditor;
        ShowParents: Serenity.LookupEditor;
        ShowChildren: Serenity.LookupEditor;
        ShowSiblings: Serenity.BooleanEditor;
        ShowAllrelated: Serenity.BooleanEditor;
    }

    export class GraphParameterForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.GraphParameter';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphParameterForm.init)  {
                GraphParameterForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = FormatLookupEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(GraphParameterForm, [
                    'GraphKey', w0,
                    'ThemeKey', w0,
                    'InstanceKey', w0,
                    'NodeKey', w1,
                    'ShowParents', w0,
                    'ShowChildren', w0,
                    'ShowSiblings', w2,
                    'ShowAllrelated', w2
                ]);
            }
        }
    }
}
